<template>
  <div id="dvGalPr">
    <div class="dvObr">
      <div class="dvImg" v-for="item in arrObr" :key="item.src">
        <a class="aImg" data-fancybox="gallery" :href="item.href">
          <img :src="item.src" />
        </a>
      </div>
      <div class="dvVid" v-if="zobrazVideo">
        <a
          class="aVideo"
          v-bind:href="hrVidea"
          data-fancybox-plyr
          data-fancybox="gallery"
        >
          <video width="100%" autoplay muted loop>
            <source v-bind:src="srcVidea" type="video/mp4" />
            <img src="https://server.recomp.cz/video/player.png" />
            Your browser does not support the video tag. \
          </video>
        </a>
      </div>
      <a
        style="display: none"
        class="aOdkSkr"
        data-fancybox="gallery"
        v-for="item in arrOdkSkr"
        :key="item.src"
        :href="item.href"
      >
        <img :src="item.src" />
      </a>
    </div>
    <div class="dvJump">
      <a
        class="aJump pc"
        v-if="pocetDalsich"
        data-fancybox-trigger="gallery"
        :data-fancybox-index="startProFancy"
        href=""
        >{{ this.sklonovani(pocetDalsich) }}</a
      >
      <a
        class="aJump tablet"
        v-if="pocetDalsich"
        data-fancybox-trigger="gallery"
        :data-fancybox-index="startProFancy - 2"
        href=""
      >
        {{ this.sklonovani(pocetDalsich + 2) }}</a
      >

      <a
        class="aJump phone"
        v-if="pocetDalsich"
        data-fancybox-trigger="gallery"
        :data-fancybox-index="startProFancy - 3"
        href=""
        >{{ this.sklonovani(pocetDalsich + 3) }}</a
      >
    </div>
  </div>
</template>

<script>
import * as detail from "../page/detail.js";
//import { MojeFce } from "../global/fce.js";
/* eslint-disable */
import { Fancybox } from "@fancyapps/ui";
/* eslint-enable */
//Vue.use(Fancybox);
import "@fancyapps/ui/dist/fancybox.css";

export default {
  name: "GalerieBox",
  data() {
    return {
      arrObr: [],
      arrOdkSkr: [],
      idVidea: "",
      hrVidea: "",
      srcVidea: "kolo",
      zobrazVideo: false,
      startProFancy: false,
      pocetDalsich: 0
    };
  },
  mounted() {
    this.nactiObrazky();
  },

  methods: {
    sklonovani: function(i) {
      var arr = ["", "+\\%d další", "+\\%d další", "+\\%d dalších"]; //- 0 ,1 , 2 -5, více;

      var s = fce.sklonovani(arr, i);
      return s;
    },

    vratVideoProduktu: function() {
      var d = detail.paramDetail("opt_video");
      if (!d) return false;
      this.idVidea = d;

      /* this.hrVidea =
        "https://server.recomp.cz/video/video.php?idVidea=" + this.idVidea;
      */
      this.hrVidea = "https://server.recomp.cz/video/" + this.idVidea + ".mp4";
      this.srcVidea = "https://server.recomp.cz/video/" + this.idVidea + ".mp4";
      this.zobrazVideo = true;

      return true;
    },
    nactiObrazky: function() {
      var obrazky = $(".p-thumbnails-inner >div a.p-thumbnail");
      var obj = {};
      var mojeVue = this;
      var pomObr = [];
      Lc.log("pocetObrazku", obrazky.length);
      $(obrazky).each(function() {
        var href = $(this).attr("href");
        var src = href.replace("/big/", "/detail/");
        obj = {
          typ: "obr",
          href: href,
          src: src
        };
        pomObr.push(obj);
        //this.arrObr.push(obj);
      });

      Lc.log("vsechnyobrazky", pomObr);
      if (!obrazky.length) {
        var hlavniObr = $(".p-main-image");
        if (hlavniObr.length) {
          var href = hlavniObr.attr("href");
          var src = href.replace("/big/", "/detail/");
          obj = {
            typ: "obr",
            href: href,
            src: src
          };
          pomObr.push(obj);
        }
      }
      var video = this.vratVideoProduktu();
      var pocetViditelnychObrazku = 4;
      if (video) {
        pocetViditelnychObrazku = 3;
      }
      mojeVue.arrObr = pomObr.slice(0, pocetViditelnychObrazku);
      mojeVue.arrOdkSkr = pomObr.slice(pocetViditelnychObrazku);

      var startPozice = mojeVue.arrObr.length;
      if (video) {
        startPozice += 1;
      }

      mojeVue.pocetDalsich = mojeVue.arrOdkSkr.length;

      mojeVue.startProFancy = startPozice;
    }
  }
};
</script>
<style lang="less">
@import "../less/mixin.less";

.fancybox__slide.has-iframe .fancybox__content {
  height: 80% !important;
}
.with-fancybox {
  div#chat-application,
  #OPHWidgetWrapp,
  #___ratingbadge_0,
  #hw-87kwowifjjowiklsadh666left {
    display: none !important;
  }
}
#dvGalPr {
  .dvObr {
    .flex;
    > div {
      flex: 0 1 50%;
      overflow: hidden;
      padding: 10px;
      justify-content: center;

      @media (max-width: 1200px) {
        flex: 0 1 50%;

        &:nth-child(3),
        &:nth-child(4) {
          display: none;
        }
      }
      @media (max-width: 767px) {
        flex: 0 1 100%;

        &:nth-child(2) {
          display: none;
        }
      }
      > a {
        //display: inline-block;
        //border: 1px solid #eae6df;
        display: flex;
        border: 1px solid #efefef;
        min-height: 223px;
        flex-direction: column;
        justify-content: center;
      }
      //padding: 10px;
    }
  }
  .dvJump {
    text-align: right;
    padding-right: 2em;
    margin-bottom: 2em;
  }
  a.aJump {
    display: inline-block;
    .odkP;
    font-weight: bold;
    color: #333333;

    @media (max-width: 1199px) {
      &.pc {
        display: none;
      }
    }
    @media (min-width: 1200px) {
      &.tablet {
        display: none;
      }
    }
    @media (max-width: 767px) {
      &.tablet {
        display: none;
      }
    }
    @media (min-width: 768px) {
      &.phone {
        display: none;
      }
    }
  }
}
</style>
